import { Component, EventEmitter, HostListener, Input, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { MainLayoutService } from 'src/app/layout/services/main-layout.service';
import { DeclareApi, NHIDownloadRequestDTO, NHISendRequestDTO } from 'src/app/services/api-service/declare/declare-api';
import { CnhiEiiService } from 'src/app/services/cnhi-eii.service';
import { EasyNotificationService } from 'src/app/services/easy-notification.service';
import { FormHelper, FormHelperService } from 'src/app/services/formhelper';
import { HcrService } from 'src/app/services/hcr-service.service';
import { UserCache } from 'src/app/services/user-cache';
import { UserConfirmService } from 'src/app/services/user-confirm.service';
import { DateHelper } from 'src/app/shared/helpers/date-helper';
import { ValueTextPair, ValueTextPairNumberValue } from 'src/app/shared/models/value-text-pair';
import { big5ToUtf8, Compare, delay, Or } from 'src/app/shared/utilities';
import { OrderMedical } from './models/blue-tooth-export';
import { RegisterApi } from 'src/app/services/api-service/register/register-api';
import { HistApi } from 'src/app/services/api-service/hist/hist-api';

@Component({
  selector: 'app-cnhi-eii-test',
  templateUrl: './cnhi-eii-test.component.html',
  styleUrls: ['./cnhi-eii-test.component.css']
})
export class CnhiEiiTestComponent implements OnInit {

  @Input()
  typeCodeD = '';
  @Input()
  typeCodeU = '';
  @Input()
  upload = true;
  @Input()
  download = true;
  @Input()
  forDialog:boolean = true;

  onClose:EventEmitter<true> = new EventEmitter();

  apiType:'send'|'download'|'get' = 'send'

  formSend: FormHelper<SendBDto>;
  formDownload: FormHelper<DownloadBDto>;
  formGet: FormHelper<GetBDto>;


  SendTypeCodes:ValueTextPair[]=[
    { value:'03',text:'醫費申報資料 XML 格式'},
    { value:'05',text:'預檢醫費申報資料 XML 格式'},
    { value:'07',text:'醫療費用電子申復資料'},
    { value:'09',text:'預檢醫療費用電子申復資料'},
    { value:'26',text:'檢驗(查)每日上傳資料 XML 格式'},
  ]

  DownloadTypeCodes:ValueTextPair[]=[
    { value:'03',text:'醫費申報'},
    { value:'07',text:'申復醫費申報'},

    { value:'05',text:'預檢醫費申報'},
    { value:'09',text:'預檢申復醫費申報'},
    { value:'10',text:'電子轉診資料下載_開立電子轉診單'},
    { value:'26',text:'檢驗(查)每日上傳資料 XML 格式檢核結果回饋資料'},
    { value:'06',text:'抽樣回饋'},
    { value:'27',text:'電子轉診資料下載申請檔_管理作業 csv 下載'},
    { value:'31',text:'健保醫療資訊雲端查詢批次下載作業(新格式)'},
    { value:'33',text:'居家輕量藍牙就醫資料下載'},
  ]

  DownloadHospTypeCodes:ValueTextPair[]=[
    {value:'11',text:'門診西醫診所'},
    {value:'12',text:'門診西醫醫院'},
    {value:'13',text:'門診牙醫'},
    {value:'14',text:'門診中醫'},
    {value:'15',text:'門診洗腎'},
    {value:'19',text:'門診其他醫事機構'},
    {value:'21',text:'住診西醫診所'},
    {value:'22',text:'住診西醫醫院'},
    {value:'29',text:'住診其他醫事機構'},
    {value:'30',text:'特約藥局'},
    {value:'40',text:'物理治療所'},
    {value:'50',text:'特約檢驗所'},
  ]
  DeclareTypeCodes:ValueTextPairNumberValue[]=[
    { value:1,text:'送核'},
    { value:2,text:'補報'},
    { value:4,text:'申復送核'},
    { value:5,text:'申復補報'}
  ]

  MonthNoteTypeCodes:ValueTextPair[]=[
    { value:'1',text:'上半月'},
    { value:'2',text:'下半月'},
    { value:'3',text:'全月'},
    { value:'0',text:'不分(申復使用)'}
  ]
  downloadRequest:NHIDownloadRequestDTO[] = [];
  
  send:SendListModel[] = [];
  constructor(private fs:FormHelperService,
    private hcrService:HcrService,
    private notification:EasyNotificationService,
    private mainLayout:MainLayoutService,
    private cnhi_eii:CnhiEiiService,
    private declareApi:DeclareApi,
    private regApi:RegisterApi,
    private histApi:HistApi,
    private userConfirm:UserConfirmService) {

   }

  async ngOnInit(){
    var hospId = await this.hcrService.VisionApi.GetHospID();
    if(this.typeCodeU){
      this.SendTypeCodes = this.SendTypeCodes.filter(x=>x.value == this.typeCodeU);
    }
    if(this.typeCodeD){
      this.DownloadTypeCodes = this.DownloadTypeCodes.filter(x=>x.value == this.typeCodeD);
    }
    this.apiType = this.upload?'send':'download';
    this.formSend = this.fs.Create<SendBDto>().buildPartial({
      fileName:['',[Validators.required]],
      portNo:[0,[Validators.required]],
      typeCode:[this.typeCodeU|| '03',[Validators.required]],
    })
    this.formDownload = this.fs.Create<DownloadBDto>().buildPartial({
      fileName:['',[Validators.required]],
      portNo:[0,[Validators.required]],
      typeCode:[this.typeCodeD|| '03',[Validators.required]],
      FEE_YM:['',[Validators.required]],
      hospId:[hospId.Data,[Validators.required]],
      APPL_TYPE:['03',[Validators.required]],
      HOSP_DATA_TYPE:['11',[Validators.required]],
      APPL_DATE:['',[Validators.required]],
      seq:['001',[Validators.required]],
      FORMAT:['JSON',null],
      ORDER_DATE_S:['',null],
      ORDER_DATE_E:['',null],
      FILE_VERSION:['v2',null]
      
    })
    this.formGet = this.fs.Create<GetBDto>().buildPartial({
      downloadPath:['',[Validators.required]],
      portNo:[0,[Validators.required]],
    })
    this.getCnhiEiiTestHeight();
    this.typeChange(null);
    await this.getSend();
    await this.getDownload();
  }
  async getSend(){
    var clinicId = UserCache.getLoginClinicId();
    var ret = await this.declareApi.GetNHISendRequest(clinicId)
    
    this.send = ret.filter(x=>this.SendTypeCodes.some(y=>y.value== x.TypeCode)).sort((a,b)=>Compare(a.RequestTime,b.RequestTime)).map(x=>{
      var fileName = x.Path.substring(x.Path.lastIndexOf('\\')+1);
      
      var hospId = ''
      var hospTp = '不明';
      var feeYM = '不明';
      var applyTp = '不明';
      var monthNote = '不明';
      if(fileName.length>19){
        hospId = fileName.substring(0,10);
        hospTp = fileName.substring(10,12);
        hospTp = `[${hospTp}]${this.DownloadHospTypeCodes.find(y=>y.value==hospTp).text}`;
        feeYM = fileName.substring(12,17);
        applyTp = fileName.substring(17,18);
        applyTp = `[${applyTp}]${this.DeclareTypeCodes.find(y=>y.value.toString()==applyTp).text}`;
        monthNote = fileName.substring(18,19);
        monthNote = `[${monthNote}]${this.MonthNoteTypeCodes.find(y=>y.value.toString()==monthNote).text}`;
      }
      
      return {
        typeCode:x.TypeCode,
        reqDt:x.RequestTime,
        fileName:x.Path,
        localId:x.sLocal_ID,
        nhiId:x.sNHI_ID,
        hospId:hospId,
        HOSP_DATA_TYPE:hospTp,
        FEE_YM:feeYM,
        APPL_TYPE:applyTp,
        Month_Note:monthNote,
      }
    })
    this.downloadRequest.forEach(x=>x.Timestamp = DateHelper.formatDateTime(new Date(x.Timestamp)))
  }
  async getDownload(){
    var clinicId = UserCache.getLoginClinicId();
    this.downloadRequest = await this.declareApi.GetNHIDownloadRequest(clinicId)
    
    var a = await this.hcrService.getFiles();
    a = a.Children.find(x=>x.FullName== this.formGet.Value.downloadPath)
    
    this.downloadRequest = this.downloadRequest.filter(x=>this.DownloadTypeCodes.some(y=>y.value== x.TypeCode));
    this.downloadRequest.forEach(x=>{
      x.Timestamp = DateHelper.formatDateTime(new Date(x.Timestamp))
      x.sujestDownloadDate = DateHelper.formatDateTime(DateHelper.addMinute(new Date(x.Timestamp),30))
      x.isDownload = !!a.Children.find(y=>y.Name.startsWith(x.QueryFileName))
    });
    
  }
  
  async SendSelectFile(){
    var file = await this.hcrService.SelectFiles();
    if(file){
      this.formSend.patchValue({
        fileName:file.FullName
      });
    }
  }

  async SendB(){

    var clinicId = UserCache.getLoginClinicId();
    var port = this.formSend.Value.portNo;
    var typeCode = this.formSend.Value.typeCode;
    var path = this.formSend.Value.fileName;
    var fileName = path.substring(path.lastIndexOf('\\'));
    var check = await this.declareApi.CheckNHISend(clinicId,fileName);
    if(check==true){
      var conf = await this.userConfirm.showConfirm({
        title:'上傳作業',
        msg:'檔案名稱與先前的作業有重複，是否繼續進行',
      });
      if(!conf){
        return;
      }
    }
    this.mainLayout.EnableLoaderTimeout = false;
    this.mainLayout.showLoader();
    var ret = await this.hcrService.VisionApi.CNHIEiiSend(port,typeCode,path)
    if(ret.StatusCode!=0){
      this.notification.showError(ret.ErrorMsg);
    }else{
      this.formSend.patchValue({
        localId:ret.Data.LocalID,
        nhiId:ret.Data.NHIID
      });
      // 寫!
      await this.declareApi.NHISendRequest(clinicId,typeCode,path,ret.Data.LocalID,ret.Data.NHIID);
      await this.getSend();
    }
    this.mainLayout.hideLoader();
    this.mainLayout.EnableLoaderTimeout = true;
  }

  async DownloadB(){

    var port = this.formDownload.Value.portNo;
    var typeCode = this.formDownload.Value.typeCode;
    var path = this.formDownload.Value.fileName;
    var hospId = this.formDownload.Value.hospId;
    var FEE_YM = this.formDownload.Value.FEE_YM;
    var HOSP_DATA_TYPE = this.formDownload.Value.HOSP_DATA_TYPE;
    var APPL_TYPE = this.formDownload.Value.APPL_TYPE;
    var APPL_DATE = this.formDownload.Value.APPL_DATE;
    var dt = DateHelper.formatROCDate(new Date(),false,false).padStart(7,'0');
    var seq = this.formDownload.Value.seq.padStart(3,'0');
    

    var accessDateTime = DateHelper.formatROCDate(new Date(),false,true)
    var queryFileName = `${hospId}-${dt}-${seq}.txt`;
    var queryContent = '';
    if(typeCode=='33'){
      var FORMAT = this.formDownload.Value.FORMAT;
      var ORDER_DATE_S = this.formDownload.Value.ORDER_DATE_S;
      var ORDER_DATE_E = this.formDownload.Value.ORDER_DATE_E;
      var FILE_VERSION = this.formDownload.Value.FILE_VERSION;
      if(!ORDER_DATE_E || !ORDER_DATE_S){
        this.notification.showError('就診日期起訖不得為空')
        return;
      }
      queryContent = 
`FORMAT=${FORMAT}
ORDER_DATE_S=${ORDER_DATE_S}
ORDER_DATE_E=${ORDER_DATE_E}
FILE_VERSION=${FILE_VERSION}
`
    }else{
      queryContent=`FEE_YM=${FEE_YM}\n`+
      `APPL_TYPE=${APPL_TYPE}\n`+
      `HOSP_DATA_TYPE=${HOSP_DATA_TYPE}\n`+
      `APPL_DATE=${APPL_DATE}`;
    }
    this.mainLayout.EnableLoaderTimeout = false;
    this.mainLayout.showLoader();
    // 查詢條件寫檔
    var saveRet = await this.hcrService.SaveTextAs(`CNHIEii_tmp\\${accessDateTime}\\${queryFileName}`,
      queryContent);

    var path:string = saveRet.Returns;

    // 測試流程可以開展示模式喔
    // 提交下載條件
    var ret = await this.hcrService.VisionApi.CNHIEiiDownload(port, typeCode, path)

    if(ret.StatusCode!=0){
      this.notification.showError(ret.ErrorMsg);
    }else{
      // 寫!
      var clinicId = UserCache.getLoginClinicId();
      await this.declareApi.CreateNHIDownloadRequest(clinicId,typeCode,FEE_YM,ret.Data.LocalID,ret.Data.NHIID,queryFileName)
      // 拿
      //var downloadFolder =path.substring(0,path.lastIndexOf('\\'));
      // var getRet = await this.hcrService.VisionApi.CNHIEiiGet(0,downloadFolder,ret.Data.LocalID,ret.Data.NHIID);

      // if(getRet.StatusCode!=0){
      //   this.notification.showError(getRet.ErrorMsg);
      //   return false;
      // }
      await this.getDownload();
    }
    this.mainLayout.hideLoader();
    this.mainLayout.EnableLoaderTimeout = true;
  }
  async GetB(item:NHIDownloadRequestDTO){
      var c= await this.userConfirm.showConfirm({
        title:'警告！',
        msg:'使用API進行檔案取得需約5分鐘左右的等待，期間將暫時無法進行其他操作(重新整理網頁無法也取消)。是否要繼續進行？'
      })
      if(!c){
        return
      }
      var port = this.formGet.Value.portNo;
      var downloadFolder =`${this.formGet.Value.downloadPath}\\${item.sLocal_ID}`;
      var localId = item.sLocal_ID;
      var nhiid = item.sNHI_ID;
      this.mainLayout.EnableLoaderTimeout = false;
      this.mainLayout.showLoader();
      if(this.hcrService.isDemoMode && this.is33){
        await this.hcrService.SaveTextAs(`輕量藍芽就醫資料下載\\${item.sLocal_ID}\\a.txt`,'12345')
        await delay(1000)
      }
      
      var getRet = await this.hcrService.VisionApi.CNHIEiiGet(port,downloadFolder,localId,nhiid);

      this.mainLayout.hideLoader();
      this.mainLayout.EnableLoaderTimeout = true;
      if(getRet.StatusCode!=0){
        this.notification.showError(getRet.ErrorMsg);

      } else{
        await this.hcrService.ConfirmOpenDir('下載完成','下載至 ' + downloadFolder,downloadFolder);
      }

  }
  async GetSelectFolder(){
    var file = await this.hcrService.SelectFolder();
    if(file){
      this.formGet.patchValue({
        downloadPath:file.FullName
      });
    }
  }
  close(){
    this.onClose.emit(true);
  }

  bodyHeight = document.body.clientHeight;
  cnhiEiiTestHeight:string = '';
  cnhiEiiTestInsideHeight:string = '';
  getCnhiEiiTestHeight() {
    const useBodyHeight = this.bodyHeight - 60;
    this.cnhiEiiTestHeight = useBodyHeight + 'px';
    this.cnhiEiiTestInsideHeight = useBodyHeight - 30 + 'px';
  }
  hasResize;
  @HostListener('window:resize', ['$event'])
	onResize(event) {
    this.bodyHeight = document.body.clientHeight;
		this.getCnhiEiiTestHeight();
	}
  is33 = false;
  downloadFolder = 'declare_tmp'
  async typeChange(evt){
    this.is33 = this.formDownload.Value.typeCode == '33';
    if(this.is33){
      var i = await  this.hcrService.getFullFiles('')
      this.downloadFolder = '輕量藍芽就醫資料下載'
      this.formGet.patchValue({
        downloadPath:`${i.FullName}\\${this.downloadFolder}`
      })
    }
  }
  async import33(item:NHIDownloadRequestDTO){
    //GetZippedFiles
    var a = await this.hcrService.getFiles();
    a = a.Children.find(x=>x.FullName== this.formGet.Value.downloadPath)
    var f = a.Children.find(y=>y.Name.startsWith(item.QueryFileName)&&y.IsDirectory==false)
    var ff = await this.hcrService.GetZippedFiles(`${f.Path}\\${f.Name}`,'3537011352');
    var utfStr = big5ToUtf8(atob(ff.Children[0].Content));
    var content = JSON.parse(utfStr) as OrderMedical[]
    var resultMsg:string[] = []
    var d = await this.userConfirm.showWaiter('資料匯入中','',{width:1000})
    var setMsg = (m:string[])=>{
      var msg = [...m,...resultMsg];
      d.msg = msg.join('\n');
    }
    d.disableYes = true;
    var eCount = 0;
    for(let i=0;i<content.length;i++){
      var rm = `${content[i].A12} ${content[i].paname} 過卡時間:${content[i].A17} `
      setMsg([
        `第 ${i} 筆, 共 ${content.length} 筆...`,
        rm + '...匯入中...'
      ])
      try{
        await this.histApi.saveBlueTooth(content[i]);
        resultMsg.push(`${rm} 匯入完成！`)        
      }catch(e){
        eCount ++;
        resultMsg.push(`${rm} 匯入失敗！(${e.message})`)
      }
      setMsg([
        `第 ${i} 筆, 共 ${content.length} 筆...失敗 ${eCount} 筆`,
      ])
    }
    setMsg([
      `執行匯入 ${content.length} 筆,成功 ${content.length-eCount} 筆 ,失敗 ${eCount} 筆`,
      `----------------------------------------`
    ])
    d.wait = 'done';    
    d.disableYes = false;
  }
  
}

interface SendBDto{
  portNo:number;
  fileName:string;
  typeCode:string;
  localId:string;
  nhiId:string;
}

interface DownloadBDto{
  portNo:number;
  fileName:string;
  typeCode:string;
  localId:string;
  nhiId:string;
  FEE_YM:string;
  APPL_TYPE:string;
  HOSP_DATA_TYPE:string;
  APPL_DATE:string;
  hospId:string
  seq:string;
  FORMAT:string;
  ORDER_DATE_S:string;
  ORDER_DATE_E:string;
  FILE_VERSION:string;

}

interface GetBDto{
  portNo:number;
  downloadPath:string;
  localId:string;
  nhiId:string;
}


interface SendListModel{
  fileName:string;
  typeCode:string;
  localId:string;
  nhiId:string;
  FEE_YM:string;
  APPL_TYPE:string;
  HOSP_DATA_TYPE:string;
  hospId:string;
  reqDt:string;
  Month_Note:string;
}